module.exports = __webpack_public_path__ + "0234cef3a97238a4bb08bb445c70111a.png";